module.exports = __webpack_public_path__ + "static/media/us-east-1-map-red.28f8463a.svg";